module.exports = __webpack_public_path__ + "1836ac12cbb150307d7aac28c6b3cfa4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/pirate-hideaway.png
// module id = 2854
// module chunks = 0